import { useQuery } from '@tanstack/react-query';
import { fetcher } from '@/lib/queryClient';
import { useAuth } from '@/hooks/use-auth';
import { useEffect } from 'react';
import type { ActivePurchase } from '@/types/game';

export function useActivePurchase(gameId: number | null, isFree: boolean | undefined) {
  const { user } = useAuth();

  const {
    isLoading,
    error,
    data: activePurchase,
    refetch,
  } = useQuery<ActivePurchase>({
    queryKey: ['/api/games', gameId, 'active-purchase'],
    queryFn: fetcher,
    enabled: !!user && !!gameId && !isFree,
  });

  useEffect(() => {
    if (user && !isFree) {
      refetch();
    }
  }, [user, isFree, refetch]);

  return { activePurchase, isLoading, error, refetch };
}
